import styled from "styled-components";
import { useUserDetail } from "../../../hooks/useUserDetail";
import { Gender, Receiver } from "../../../lib/apollo/graphql/generated";
import { formatDate, formatPhoneNumber } from "../../../utilities/format";
import LeftLabel from "../../common/components/LeftLabel";
import ProfileSection from "./ProfileSection";
import RelatedUsersBox from "./RelatedUsersBox";
import PointBox from "./PointBox";
import BoxWithShadow from "../../common/components/BoxWithShadow";

export default function GuardianDetail() {
  const {
    models: { data, loading, isDeletedUser },
    operations: { moveToDetailPage },
  } = useUserDetail("guardians");

  return (
    <>
      <ProfileSection
        type="guardians"
        name={data?.name}
        id={data?.id}
        role={data?.role?.name?.toString()}
        src={data?.avatar?.uri}
        isLoading={loading}
        isDeletedUser={isDeletedUser}
      >
        <LeftLabel label="이름" info={data?.name} />
        <LeftLabel
          label="성별"
          info={data?.gender === Gender.Male ? "남성" : "여성"}
        />
        <LeftLabel
          label="전화번호"
          info={isDeletedUser ? "-" : formatPhoneNumber(data?.phone)}
        />
        <LeftLabel
          label="생년월일"
          info={formatDate(data?.dateOfBirth?.toString())}
        />
        <LeftLabel label="포인트" info={`${data?.point}P`} />
        <LeftLabel label="수급자" info={`${data?.receivers?.length || 0}명`} />
        <LeftLabel
          label="가입일"
          info={formatDate(data?.createdAt, "YYYY.MM.DD HH:MM")}
        />
        <LeftLabel
          label="탈퇴일"
          info={formatDate(data?.deletedAt, "YYYY.MM.DD HH:MM")}
        />
      </ProfileSection>
      <BoxWithShadow>
        <DetailSection>
          <RelatedUsersBox
            type={"receivers"}
            users={data?.receivers as Receiver[]}
            onUserClick={(receiverId) =>
              moveToDetailPage(receiverId, "receivers")
            }
          />
          <PointBox type={"guardians"} />
        </DetailSection>
      </BoxWithShadow>
    </>
  );
}

const DetailSection = styled.section(({ theme }) => ({
  marginLeft: theme.spacing.small,
  height: "100%",
  flexGrow: 1,
  overflowY: "scroll",
  display: "flex",
  gap: theme.spacing.small,
}));
